import React from 'react';
import { colors } from '../../../lib/colors';
import { I_EMPTY_CONDITION } from '../../../types/images';
import dayjs from 'dayjs';
import { CONDITION_TYPE } from '../../../lib/varialbe';
import { RegularText } from '@/lib/Text';
import { getFeedSource, getFeedScheduleTitle } from '../../../lib/feedSource';

const FeedScheduleItem = ({ item, scheduleReport }: any) => {
    const scheduleInfo = scheduleReport?.scheduleInfo;
    const condition = scheduleReport?.condition;
    const goal = scheduleReport?.goal;
    const source = getFeedSource(item);
    const isGroup = source === 'group';
    const isNewOpportunity = source === 'newOpportunity';

    let conditionText = condition
        ? CONDITION_TYPE.find((item) => item.code === condition.todayCondition)?.text
        : '기록 안함';

    let conditionImg = condition
        ? CONDITION_TYPE.find((item) => item.code === condition.todayCondition)?.src
        : I_EMPTY_CONDITION;

    // 운동 기록이 있으면 리스트에서도 개수 인디케이터 노출
    const workoutExerciseCount = Array.isArray(scheduleReport?.workoutRecord?.exercises)
        ? scheduleReport.workoutRecord.exercises.filter((ex: any) => ex?.exerciseName).length
        : 0;

    return (
        <div className="flex items-center bg-[#F7F8FA] border border-solid border-[#ECEDEE] py-[10px] px-[20px] mx-[32px] mt-[12px] rounded-[12px] gap-[16px] flex-wrap">
            {/* 날짜 */}
            <span className="text-[13px] text-[#5A6370]">
                {dayjs(scheduleInfo?.startTime).format('MM/DD(ddd) HH:mm')}
            </span>

            {/* 구분점 */}
            <div className="w-[3px] h-[3px] rounded-full bg-[#C1C7CD]" />

            {isGroup || isNewOpportunity ? (
                /* 그룹: 세션명 */
                <div
                    className={`border-[0.5px] border-solid rounded-[6px] px-[7px] py-[1px] ${
                        isNewOpportunity
                            ? 'bg-[#F5F3FF] border-[#DDD6FE]'
                            : 'bg-[#ECFDF5] border-[#A7F3D0]'
                    }`}
                >
                    <RegularText fontSize={13} lineHeight={18} color={isNewOpportunity ? '#6D28D9' : '#059669'}>
                        {getFeedScheduleTitle(item)}
                    </RegularText>
                </div>
            ) : (
                /* PT: 회차 */
                <div className="bg-[#E4EDFC] border-[0.5px] border-solid border-[#D2DDF4] rounded-[6px] px-[7px] py-[1px]">
                    <RegularText fontSize={13} lineHeight={18} color={colors.primary}>
                        {`${scheduleInfo?.currentSession || '?'}/${scheduleInfo?.totalSession || '?'}회차`}
                    </RegularText>
                </div>
            )}

            {/* 컨디션 — PT 전용 (그룹은 condition 없음) */}
            {!isGroup && !isNewOpportunity && (
                <>
                    <div className="w-[3px] h-[3px] rounded-full bg-[#C1C7CD]" />
                    <div className="flex items-center gap-[4px]">
                        {conditionImg && <img src={conditionImg} className="w-[18px] h-[18px]" alt="" />}
                        <span className="text-[13px] text-[#5A6370]">{conditionText}</span>
                    </div>
                </>
            )}

            {/* 수강권/목표 (있을 때만) */}
            {isGroup && scheduleInfo?.ticketName && (
                <>
                    <div className="w-[3px] h-[3px] rounded-full bg-[#C1C7CD]" />
                    <span className="text-[13px] text-[#8F97A7] truncate max-w-[200px]">{scheduleInfo.ticketName}</span>
                </>
            )}
            {!isGroup && !isNewOpportunity && goal?.context && (
                <>
                    <div className="w-[3px] h-[3px] rounded-full bg-[#C1C7CD]" />
                    <span className="text-[13px] text-[#8F97A7] truncate max-w-[200px]">{goal.context}</span>
                </>
            )}

            {/* 운동 기록 인디케이터 */}
            {workoutExerciseCount > 0 && (
                <>
                    <div className="w-[3px] h-[3px] rounded-full bg-[#C1C7CD]" />
                    <div className="flex items-center gap-[3px] bg-[#EFF3FB] rounded-[6px] px-[7px] py-[1px]">
                        <span className="text-[12px]">🏋️</span>
                        <RegularText fontSize={13} lineHeight={18} color={colors.primary}>
                            {`운동 ${workoutExerciseCount}개`}
                        </RegularText>
                    </div>
                </>
            )}
        </div>
    );
};

export default FeedScheduleItem;
